export default "__VITE_ASSET__0c4a7ad5__"